import styled from "styled-components/macro";

export const StyledContainer = styled.div`
  padding: 25px;
  text-align: center;

  div {
    background: #ddd;
    text-align: center;
  }

  .inner {
    padding: 35px;
    width: 80%;
    background: white;
    border-radius: 15px;
    margin: auto;
    text-align: left;
  }

  h1 {
    margin: 0 0 15px 0;
    text-align: left;
  }

  h2 {
    margin-top: 25px;
  }

  ul {
    margin-top: 25px;

    li {
      margin-bottom: 5px;
    }
  }
`;
